import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'

import { Container, LinearProgress, Link, Stack, Text } from '../components'
import { NoMatch } from '.'
import { queries } from '../graphql'
import { BankTransferZum } from './funds/contribute'

export function CharityPaylink({ showCharityName = true }) {
  const { id: charityId, token: charityToken } = useParams()
  const { data: { charity } = {}, loading: loadingCharity } = useQuery(queries.charities.charity, {
    variables: { charityId, charityToken },
  })

  if (loadingCharity) return <LinearProgress />
  if (!charity)
    return (
      <NoMatch title="">
        <Text.Body>
          The link you are trying to access is no longer valid. It has either been completed or has been replaced with a
          new link.
          <br />
          For more information or for assistance with a new link, please contact{' '}
          <Link href="mailto:charitysupport@givewise.ca">charitysupport@givewise.ca</Link>.
        </Text.Body>
      </NoMatch>
    )
  const { accountName: name, id: charityBn } = charity
  return (
    <Container maxWidth="lg">
      <Stack sx={{ width: '100%' }}>
        {showCharityName ? (
          <>
            <Text.H1>{name}</Text.H1>
            <Text.H2>
              <i>#{charityBn}</i>
            </Text.H2>
          </>
        ) : (
          ''
        )}
        <BankTransferZum />
      </Stack>
    </Container>
  )
}
